import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"
import { OBJECT_DETECTION_OPTIONS } from "../constants/object_detection_options"

export default class extends Controller {
  static targets = ["eventType", "labelsContainer", "labelsSelect"]

  declare readonly eventTypeTarget: HTMLSelectElement
  declare readonly labelsContainerTarget: HTMLElement
  declare readonly labelsSelectTarget: HTMLSelectElement
  private tomSelect: TomSelect | null = null

  connect(): void {
    this.toggleLabels()
  }

  toggleLabels(): void {
    const isObjectDetection = this.eventTypeTarget.value === "object_detection"
    this.labelsContainerTarget.classList.toggle("hidden", !isObjectDetection)

    if (isObjectDetection && !this.tomSelect) {
      this.initializeTomSelect()
    }
  }

  private initializeTomSelect(): void {
    this.tomSelect = new TomSelect(this.labelsSelectTarget, {
      plugins: ['remove_button'],
      maxItems: null,
      valueField: 'value',
      labelField: 'text',
      searchField: ['text'],
      options: OBJECT_DETECTION_OPTIONS
    })
  }
} 